import React, { useState } from "react";
import { FiCheck, FiCopy } from "react-icons/fi";

/**
 * Fenced code block with a language label and a copy button.
 *
 * Previously fenced code fell through to a bare <pre> with no styling, no
 * language, and no way to copy it — the single biggest gap against Claude and
 * ChatGPT for anyone pasting an API snippet out of an answer.
 */
export default function CodeBlock({ code, language }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (error) {
      console.error("Could not copy code block:", error);
    }
  };

  return (
    <div className="my-4 overflow-hidden rounded-xl bg-iq-code-bg">
      <div className="flex items-center justify-between gap-3 border-b border-white/10 px-3.5 py-2">
        <span className="iq-mono text-[11px] uppercase tracking-[0.08em] text-white/45">
          {language || "code"}
        </span>
        <button
          type="button"
          onClick={handleCopy}
          className="flex items-center gap-1.5 rounded-md px-2 py-1 text-[11.5px] font-medium text-white/60 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
        >
          {copied ? <FiCheck size={13} /> : <FiCopy size={13} />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="overflow-x-auto px-4 py-3.5">
        <code className="iq-mono text-[13px] leading-[1.65] text-iq-code-ink">
          {code}
        </code>
      </pre>
    </div>
  );
}
